import React from 'react';
import { List } from 'semantic-ui-react';
import RequestAttachmentListItem from '../attachments/components/RequestAttachmentListItem';
import RequestCreatedOnListItem from '../containers/RequestCreatedOnListItem';
import RequestDictionariesListItem from '../datasets/containers/RequestDictionariesListItem';
import RequesterListItem from '../containers/RequesterListItem';
import RequestDatasetListItem from '../datasets/containers/RequestDatasetListItem';
import RequestTransferredOnListItem from '../containers/RequestTransferredOnListItem';
import RequestTransferredAsListItem from '../containers/RequestTransferredAsListItem';
import RequestDatasetOwnersListItem from '../datasets/containers/RequestDatasetOwnersListItem';
import SystemCohortListItem from '../cohorts/containers/SystemCohortListItem';
import Selectors from '../hooks/selectors';

const RequestSummaryList = ({
  category,
  children,
  code,
  withLinks,
}) => {
  const { allowPmnTransfer, showDictionaries, showSystemCohort } = Selectors.useRequestSummaryList({ category, code });
  return (
    <List className="aridhia-request-summary-list">
      {children}
      <RequesterListItem code={code} category={category} />
      <RequestDatasetListItem code={code} category={category} link={withLinks} />
      {showSystemCohort && (<SystemCohortListItem code={code} category={category} link={withLinks} />)}
      {showDictionaries && (<RequestDictionariesListItem code={code} category={category} />)}
      <RequestAttachmentListItem code={code} category={category} />
      <RequestCreatedOnListItem code={code} category={category} />
      {(allowPmnTransfer) && (<RequestTransferredAsListItem code={code} category={category} />)}
      <RequestTransferredOnListItem code={code} category={category} />
      <RequestDatasetOwnersListItem code={code} category={category} />
    </List>
  );
};

export default RequestSummaryList;
